import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LangRedirect } from "@/components/LangLink";
import { DEFAULT_LANG } from "@/i18n";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Soluzioni from "@/pages/Soluzioni";
import Prodotti from "@/pages/Prodotti";
import Lumaven from "@/pages/Lumaven";
import LumavenLine from "@/pages/LumavenLine";
import LumavenComfort from "@/pages/LumavenComfort";
import LumavenAntitrombo from "@/pages/LumavenAntitrombo";
import Schiebler from "@/pages/Schiebler";
import SchieblerProduct from "@/pages/SchieblerProduct";
import Bendaggi from "@/pages/Bendaggi";
import BendaggioProduct from "@/pages/BendaggioProduct";
import Pressoterapia from "@/pages/Pressoterapia";
import IlMetodo from "@/pages/IlMetodo";
import Servizi from "@/pages/Servizi";
import Canali from "@/pages/Canali";
import Contatti from "@/pages/Contatti";
import TerminiCondizioni from "@/pages/TerminiCondizioni";
import { ExternalRedirect } from "@/components/ExternalRedirect";
import { IUBENDA_PRIVACY_URL, IUBENDA_COOKIE_URL } from "@/lib/iubenda";
import CompanyProfilePrint from "@/pages/CompanyProfilePrint";
import { LegacyOrNotFound } from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/:lang/company-profile-print" element={<CompanyProfilePrint />} />
          <Route path="/:lang" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="chi-siamo" element={<ChiSiamo />} />
            <Route path="soluzioni" element={<Soluzioni />} />
            <Route path="prodotti" element={<Prodotti />} />
            <Route path="prodotti/lumaven" element={<Lumaven />} />
            <Route path="prodotti/lumaven/calzini-comfort" element={<LumavenComfort />} />
            <Route path="prodotti/lumaven/calza-antitrombo" element={<LumavenAntitrombo />} />
            <Route path="prodotti/lumaven/:slug" element={<LumavenLine />} />
            <Route path="prodotti/schiebler" element={<Schiebler />} />
            <Route path="prodotti/schiebler/:slug" element={<SchieblerProduct />} />
            <Route path="prodotti/bendaggi" element={<Bendaggi />} />
            <Route path="prodotti/bendaggi/:slug" element={<BendaggioProduct />} />
            <Route path="prodotti/pressoterapia" element={<Pressoterapia />} />
            <Route path="prodotti/wero-swiss" element={<LangRedirect to="/prodotti/bendaggi" />} />
            <Route path="prodotti/lem" element={<LangRedirect to="/prodotti/pressoterapia" />} />
            <Route path="il-metodo" element={<IlMetodo />} />
            <Route path="servizi" element={<Servizi />} />
            <Route path="canali" element={<Canali />} />
            <Route path="contatti" element={<Contatti />} />
            <Route path="privacy-policy" element={<ExternalRedirect to={IUBENDA_PRIVACY_URL} />} />
            <Route path="cookie-policy" element={<ExternalRedirect to={IUBENDA_COOKIE_URL} />} />
            <Route path="termini-e-condizioni" element={<TerminiCondizioni />} />
            <Route path="*" element={<LegacyOrNotFound />} />
          </Route>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
